import React, { useState, useMemo, useEffect, useRef } from "react";
import moment from "moment";
import {
  Accordion,
  AccordionSummary,
  AccordionDetails,
  Typography,
  Grid,
  Chip,
  Box,
  IconButton,
  TableContainer,
  Table,
  TableHead,
  TableRow,
  TableCell,
  TableBody,
  Paper,
  CircularProgress,
  Dialog,
  DialogContent,
} from "@mui/material";
import StoreSearch from "../../../Campaign/StoreSearch";
import Decrypt from "../../../../../shared/utils/Decrypt";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
import styles from "../../JobBatch.module.css";
import PdfIcon from "../../../../../shared/assets/icons/PdfIcon.png";
import ModalToUpdateBatches from "../../ModalToUpdateBatches";
import RecceReport from "../../../../RFPDashboard/RecceApproval/RecceReport";

const Completed = ({
  completedBatches,
  setCompletedBatches,
  totalCompletedBatches,
  isAllBatchesLoading,
  forbatch,
  acceptedBatches,
  setAcceptedBatches,
  setTotalCompletedBatches,
  setAvailableBatches,
  fetchAllJobsBasedOnCampaignId,
  fetchAllBatchesBasedOnCampaignId,
  campaignData, // Make sure this prop is passed from parent
}) => {
  const [expandedBatch, setExpandedBatch] = useState(null);
  const [openModalToUpdateBatch, setOpenModalToUpdateBatch] = useState(false);
  const [detailsOfBatchSelected, setDetailsOfBatchSelected] = useState();
  const [openRecceReport, setOpenRecceReport] = useState(false);
  const [currentRecceJob, setCurrentRecceJob] = useState(null);
  const batchRefs = useRef({});
  const containerRef = useRef(null);

  // Check if Recce service is needed in this campaign
  const isRecceNeeded =
    campaignData?.scopeOfWork?.servicesNeeded?.includes("Recce");

  const handleAccordionToggle = (batchTitle) => (event) => {
    event.stopPropagation();
    setExpandedBatch((prev) => (prev === batchTitle ? null : batchTitle));
  };

  // Function to handle opening the recce report
  const handleOpenRecceReport = (job) => {
    setCurrentRecceJob(job);
    setOpenRecceReport(true);
  };

  // Function to handle closing the recce report
  const handleCloseRecceReport = () => {
    setOpenRecceReport(false);
  };

  // Handle batch updates
  const handleBatchUpdate = (updatedBatch) => {
    setAcceptedBatches((prev) =>
      prev.map((b) => (b._id === updatedBatch._id ? updatedBatch : b)),
    );
    if (detailsOfBatchSelected?._id === updatedBatch._id) {
      setDetailsOfBatchSelected(updatedBatch);
    }
  };

  // Handle the logic to update batches with jobs
  // useEffect(() => {
  //   if (forbatch && acceptedBatches.length > 0) {
  //     const updatedBatches = acceptedBatches.map((batch) => ({
  //       ...batch,
  //       jobs: [],
  //       totalPayment: 0,
  //     }));

  //     forbatch.forEach((job) => {
  //       const batch = updatedBatches.find(
  //         (batch) => batch._id === job.batchOfJobsForInstallationPartnerId
  //       );
  //       if (batch) {
  //         batch.jobs.push(job);
  //       }
  //     });

  //     // Calculate total payment and date range for each batch
  //     updatedBatches.forEach((batch) => {
  //       if (batch.jobs.length > 0) {
  //         const jobDates = batch.jobs.map(
  //           (job) => new Date(job.jobStartingDate)
  //         );
  //         const completionDates = batch.jobs.map(
  //           (job) => new Date(job.jobCompletionDate)
  //         );

  //         const earliestDate = new Date(
  //           Math.min(...jobDates.map((date) => date.getTime()))
  //         );
  //         const latestDate = new Date(
  //           Math.max(...completionDates.map((date) => date.getTime()))
  //         );

  //         batch.dateRange = `${earliestDate.toLocaleDateString()} - ${latestDate.toLocaleDateString()}`;

  //         // Calculate total payment for the batch
  //         batch.totalPayment = batch.jobs.reduce(
  //           (sum, job) => sum + (job.paymentAmount || 0),
  //           0
  //         );
  //       } else {
  //         batch.dateRange = "No Dates Available";
  //       }
  //     });

  //     setAcceptedBatches((prevBatches) => {
  //       const prevBatchesString = JSON.stringify(prevBatches);
  //       const updatedBatchesString = JSON.stringify(updatedBatches);
  //       return prevBatchesString !== updatedBatchesString
  //         ? updatedBatches
  //         : prevBatches;
  //     });

  //     // Update total completed batches count
  //     const completedBatchesCount = updatedBatches.filter((batch) =>
  //       batch.jobs.every((job) => job.status === 2)
  //     ).length;
  //     setTotalCompletedBatches(completedBatchesCount);
  //   }
  // }, [forbatch, acceptedBatches, setAcceptedBatches, setTotalCompletedBatches]);

  useEffect(() => {
    if (completedBatches && completedBatches.length > 0) {
      const updatedBatches = completedBatches.map((batch) => {
        // Add jobs to each batch

        // Calculate date range if jobs exist
        if (batch?.jobs?.length > 0) {
          const jobDates = batch.jobs.map(
            (job) => new Date(job.jobStartingDate),
          );
          const completionDates = batch.jobs.map(
            (job) => new Date(job.jobCompletionDate),
          );

          const earliestDate = new Date(
            Math.min(...jobDates.map((date) => date.getTime())),
          );
          const latestDate = new Date(
            Math.max(...completionDates.map((date) => date.getTime())),
          );

          batch.dateRange = `${earliestDate.toLocaleDateString()} - ${latestDate.toLocaleDateString()}`;
          batch.totalPayment = batch.jobs.reduce(
            (sum, job) => sum + (job.paymentAmount || 0),
            0,
          );
        } else {
          batch.dateRange = "No Dates Available";
          batch.totalPayment = 0;
        }

        return batch;
      });

      setCompletedBatches(updatedBatches);

      // Calculate total accepted batches count
      // const acceptedBatchesCount = updatedBatches.filter((batch) =>
      //   batch.jobs.some(
      //     (job) =>
      //       job.status === 0 && new Date(job.jobCompletionDate) < new Date()
      //   )
      // ).length;
      // setAcceptedBatches(acceptedBatchesCount);
    }
  }, [completedBatches, setCompletedBatches]);

  const searchData = useMemo(() => {
    const result = [];

    completedBatches.forEach((batch) => {
      batch.jobs?.forEach((job) => {
        result.push({
          id: job._id,
          storeName: job.storeName,
          batchTitle: batch.batchTitle,
          targetId: batch._id,
          subText: `Batch: ${batch.batchTitle}`,
        });
      });
    });

    return result;
  }, [completedBatches]);

  return (
    <Grid ref={containerRef} className={`${styles.scrollableContainer}`}>
      <div className="mx-3 py-2 sticky top-0 z-20 bg-white">
        <StoreSearch
          data={searchData}
          searchKey="storeName"
          placeholder="Search Store Name"
          containerRef={containerRef}
          targetRefs={batchRefs}
          onSelect={(item) => {
            setExpandedBatch(item.batchTitle);
          }}
        />
      </div>
      {isAllBatchesLoading ? (
        <div className={styles.noJobsStyle}>
          <CircularProgress />
        </div>
      ) : completedBatches.length > 0 ? (
        completedBatches.map((batch, index) => (
          <Grid
            ref={(el) => (batchRefs.current[batch._id] = el)}
            item
            xs={12}
            md={12}
            key={index}
            my={1}
            mx={2}
          >
            <Accordion expanded={expandedBatch === batch.batchTitle}>
              <AccordionSummary
                expandIcon={
                  <IconButton onClick={handleAccordionToggle(batch.batchTitle)}>
                    <ExpandMoreIcon />
                  </IconButton>
                }
                aria-controls={`panel-${index}-content`}
                id={`panel-${index}-header`}
              >
                <div className="flex items-center justify-between p-4 rounded-lg bg-white w-full mx-auto">
                  <div className="flex">
                    <h1 className={styles.batchTitle}>{batch.batchTitle}</h1>
                  </div>

                  <div className={styles.chipContainer}>
                    <div>
                      <Chip
                        label={`Timeline: ${moment(
                          batch?.jobStartingDate,
                        ).format("DD MMM YY")} - ${moment(
                          batch?.jobCompletionDate,
                        ).format("DD MMM YY")}`}
                        className={styles.chip}
                      />
                    </div>

                    <Chip
                      label={
                        batch.installationPartnerId
                          ? `${batch.installationPartnerId.name} - ${
                              Decrypt(
                                batch.installationPartnerId.phoneNumber,
                              ) || "N/A"
                            }`
                          : "No Contact Info"
                      }
                      className={styles.chip}
                    />
                    {/* Display Total Payment */}
                    <Chip
                      label={
                        <span>Batch Payment: ₹{batch?.paymentAmount}</span>
                      }
                      className={styles.chips}
                    />
                    {/* Status Badge */}
                    <Chip label="Complete" className={styles.amountPaid} />
                    {/* Ellipsis Button */}
                    <Chip
                      label={<span>Jobs: {batch?.jobs?.length || 0}</span>}
                      className={styles.chip}
                    />
                    <button
                      className="text-gray-400 hover:text-gray-600 text-xl rounded-full px-4 py-1 hover:bg-gray-100"
                      onClick={() => {
                        setOpenModalToUpdateBatch(true);
                        setDetailsOfBatchSelected(batch);
                      }}
                    >
                      ⋮
                    </button>
                  </div>
                </div>
              </AccordionSummary>

              <AccordionDetails className={styles.accordionDetails}>
                {/* Render Job Details Table */}
                <Box className={styles.scrollableBox}>
                  <TableContainer component={Paper}>
                    <Table>
                      <TableHead>
                        <TableRow className={styles.tableHeader}>
                          <TableCell className={styles.tableCell}>
                            ADDRESS
                          </TableCell>
                          <TableCell className={styles.tableCell}>
                            STORE MANAGER
                          </TableCell>
                          <TableCell className={styles.tableCell}>
                            PRODUCT TYPE
                          </TableCell>
                          <TableCell className={styles.tableCell}>
                            JOB PAY
                          </TableCell>
                          {/* <TableCell className={styles.tableCell}>KAM APPROVAL</TableCell>
                            <TableCell className={styles.tableCell}>CLIENT APPROVAL</TableCell> */}
                          {/* Conditionally render RECCE REPORT column */}
                          {isRecceNeeded && (
                            <TableCell className={styles.tableCell}>
                              RECCE REPORT
                            </TableCell>
                          )}
                          <TableCell className={styles.tableCell}>
                            JOB STATUS
                          </TableCell>
                          <TableCell className={styles.tableCell}>
                            IP PAY
                          </TableCell>
                        </TableRow>
                      </TableHead>
                      <TableBody>
                        {batch.jobs?.map((row, index) => (
                          <TableRow key={index}>
                            <TableCell className={styles.tableCell}>
                              <div className={styles.sharedTextStyle}>
                                <span>{row.storeName}</span>
                              </div>
                              <div className={styles.address2}>
                                <span>{row.city}</span>,{" "}
                                <span>{row.state}</span>,{" "}
                                <span>{row.zipCode}</span>
                              </div>
                            </TableCell>
                            <TableCell className={styles.tableCell}>
                              <div className={styles.sharedTextStyle}>
                                {row.storeOwnerName}
                              </div>
                              <div className={styles.storeManagerContact}>
                                {row.storeOwnerPhoneNumber}
                              </div>
                            </TableCell>
                            <TableCell className={styles.tableCell}>
                              <div className={styles.sharedTextStyle}>
                                {row?.productId?.productType || "NA"}
                              </div>
                            </TableCell>
                            <TableCell className={styles.tableCell}>
                              <div className={styles.sharedTextStyle}>
                                ₹{row.paymentAmount}
                              </div>
                            </TableCell>
                            {/* <TableCell className={styles.tableCell}>
                                <Chip
                                  label={
                                    row.jobApprovalStatus?.adminStatus === 1
                                      ? "Approved"
                                      : row.jobApprovalStatus?.adminStatus === -1
                                        ? "Rejected"
                                        : "Pending"
                                  }
                                  className={
                                    row.jobApprovalStatus?.adminStatus === 1
                                      ? styles.amountPaid
                                      : row.jobApprovalStatus?.adminStatus === -1
                                        ? styles.blacklisted
                                        : styles.pending
                                  }
                                />
                              </TableCell> */}
                            {/* <TableCell className={styles.tableCell}>
                                      <div className={styles.sharedTextStyle}>
                                        {row?.kamApproval || "NA"}
                                      </div>
                                    </TableCell> */}

                            {/* <TableCell className={styles.tableCell}>
                                      <div className={styles.sharedTextStyle}>
                                        {row?.clientApproval || "NA"}
                                      </div>
                                    </TableCell> */}
                            {/* <TableCell className={styles.tableCell}>
                                <Chip
                                  label={
                                    row.jobApprovalStatus?.clientStatus === 1
                                      ? "Approved"
                                      : row.jobApprovalStatus?.clientStatus === -1
                                        ? "Rejected"
                                        : "Pending"
                                  }
                                  className={
                                    row.jobApprovalStatus?.clientStatus === 1
                                      ? styles.amountPaid
                                      : row.jobApprovalStatus?.clientStatus === -1
                                        ? styles.rejected
                                        : styles.pending
                                  }
                                />
                              </TableCell> */}
                            {/* Conditionally render recce report cell */}
                            {isRecceNeeded && (
                              <TableCell className={styles.tableCell}>
                                <div
                                  style={{
                                    display: "flex",
                                    alignItems: "center",
                                    cursor: "pointer",
                                  }}
                                  onClick={() => handleOpenRecceReport(row)}
                                >
                                  <img
                                    src={PdfIcon}
                                    alt="PDF Icon"
                                    style={{
                                      width: "20px",
                                      height: "20px",
                                      marginRight: "8px",
                                    }}
                                  />
                                </div>
                              </TableCell>
                            )}
                            <TableCell className={styles.tableCell}>
                              <Chip
                                label={
                                  row.status === 0
                                    ? "Pending"
                                    : row.status === 2
                                      ? "Complete"
                                      : row.status
                                }
                                className={
                                  row.status === 2
                                    ? styles.amountPaid
                                    : row.status === 0
                                      ? styles.pending
                                      : ""
                                }
                              />
                            </TableCell>
                            <TableCell className={styles.tableCell}>
                              <Chip
                                label={row.paymentCredited ? "Paid" : "Pending"}
                                className={
                                  row.paymentCredited
                                    ? styles.amountPaid
                                    : styles.pending
                                }
                              />
                            </TableCell>
                          </TableRow>
                        ))}
                      </TableBody>
                    </Table>
                  </TableContainer>
                </Box>
              </AccordionDetails>
            </Accordion>
          </Grid>
        ))
      ) : (
        <div className={styles.noJobsStyle}>
          <Typography
            variant="h6"
            className={`${styles.noJobsBox} ${styles.noJobsText}`}
          >
            No batches available
          </Typography>
        </div>
      )}

      {openModalToUpdateBatch && (
        <ModalToUpdateBatches
          openModal={openModalToUpdateBatch}
          setOpenModalToUpdateBatch={setOpenModalToUpdateBatch}
          batch={detailsOfBatchSelected}
          setAvailableBatches={setAvailableBatches}
          fetchAllJobsBasedOnCampaignId={fetchAllJobsBasedOnCampaignId}
          fetchAllBatchesBasedOnCampaignId={fetchAllBatchesBasedOnCampaignId}
          onBatchUpdate={handleBatchUpdate}
          campaignData={campaignData}
        />
      )}

      {/* Recce Report Dialog */}
      <Dialog
        open={openRecceReport}
        onClose={handleCloseRecceReport}
        maxWidth="lg"
        fullWidth
        className="custom-dialog"
        PaperProps={{
          className: "custom-dialog-paper",
        }}
      >
        <DialogContent>
          {currentRecceJob && (
            <RecceReport
              setOpen={setOpenRecceReport}
              open={openRecceReport}
              currentApproval={currentRecceJob}
              finalSpaces={[]}
              installationCheck={true}
            />
          )}
        </DialogContent>
      </Dialog>
    </Grid>
  );
};

export default Completed;
